import React from 'react';
import rightImg from '../../assets/images/about/about-img-2.png';
import avatar from '../../assets/images/icons/owner-icon.png';
import pencilIcon from '../../assets/images/icons/pencil.png';
import signature from '../../assets/images/icons/sign.png';

function About2() {
  return (
    <section className="numbers-wrapper about-two-wrapper section-padding">
      <div className="container">
        <div className="row align-items-center gy-5 gy-lg-0">
          <div className="col-lg-6">
            <div className="left-content">
              <div className="section-head">
                <span className="heading-bg">About</span>
                <h2 className="section-title mb-20">
                  We are the best-in-class products &amp; solutions
                  <span className="heading-dot" />
                </h2>
              </div>
              <h4 className="small-heading pr-80">
                We are attentive to the wishes of the customer, we always comply
                with set real terms.
              </h4>
              <p className="body-text pr-80">
                When developing a house project, specialists carefully work out
                the space, especially attentive to natural lighting. The main
                distinguishing The price of houses decorated in high-tech style
                is not the lowest, but they have a lot of positive qualities.
                Our company offers you quality services for the design.
              </p>
            </div>
            <div className="numbers-profile d-flex align-items-center flex-wrap">
              <div
                className="profile-img bg-cover"
                style={{ backgroundImage: `url(${avatar})` }}
              />
              <div className="profile-info">
                <h4 className="name">Alexander Thompson</h4>
                <span className="role">Owner of company</span>
              </div>
              <div className="signature align-self-end">
                <img src={signature} alt="signature" />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="right-content">
              <div
                className="about-thumb bg-cover"
                style={{ backgroundImage: `url(${rightImg})` }}
              />
              <div className="right-card d-flex align-items-center">
                <img src={pencilIcon} alt="icon" className="card-icon" />
                <p className="body-text">
                  We are attentive to the wishes of the customer, we always
                  comply with set real terms.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About2;
